import type { NavigationItem } from '@hetivo/hetivo-lib-web-utils';

import { ISSUES_PATH } from '../paths';

/**
 * Sets the Open-issue count on the sidebar's Issues item (SWOOP-255). Returns a new array so the input
 * is never mutated; every other item is passed through unchanged. A `count` of `undefined` (not entitled,
 * no permission, or not yet loaded) leaves the item without a badge.
 */
export function applyIssuesBadge(items: NavigationItem[], count: number | undefined, label: string): NavigationItem[] {
  if (count === undefined) {
    return items;
  }
  return items.map((item) =>
    item.path === ISSUES_PATH ? { ...item, badgeCount: count, badgeCountLabel: label } : item,
  );
}
